import { Icon } from '@chakra-ui/react';
import { BsPencil } from 'react-icons/bs';
import { IoMdAlarm, IoMdCloseCircle } from 'react-icons/io';
import { IoBanOutline, IoCheckmarkCircle } from 'react-icons/io5';

const eventStatus = [
  {
    title: 'Rascunho',
    color: 'gray',
    class: 'draft',
    icon: <Icon as={BsPencil} height={12} width={12} />,
    text: 'O evento ainda não foi terminado e se encontra em rascunho.',
  },
  {
    title: 'Publicação Pendente',
    color: 'orange',
    class: 'pendent',
    icon: <Icon as={IoMdAlarm} height={12} width={12} />,
    text: 'O evento será analisado para então ser publicado.',
  },

  {
    title: 'Evento Publicado',
    color: 'green',
    class: 'published',
    icon: <Icon as={IoCheckmarkCircle} height={12} width={12} />,
    text: '',
  },
  {
    title: 'Evento Cancelado',
    color: 'orange',
    class: 'paused',
    icon: <Icon as={IoMdCloseCircle} height={12} width={12} />,
    text: 'O evento foi cancelado.',
  },
  {
    title: 'Evento suspenso',
    color: 'red',
    class: 'suspended-responsible',
    icon: <Icon as={IoMdCloseCircle} height={12} width={12} />,
    text: 'Este evento foi suspenso',
  },
  {
    title: 'Publicação Negada',
    color: 'red',
    class: 'publication-denied',
    icon: <Icon as={IoBanOutline} height={12} width={12} />,
    text: 'O evento teve sua publicação negada.',
  },
  {
    title: 'Evento Encerrado',
    color: 'red',
    class: 'event-closed',
    icon: <Icon as={IoMdCloseCircle} height={12} width={12} />,
    text: 'O evento já aconteceu ou já teve todos seus ingressos vendidos.',
  },
  {
    title: 'Evento sem vendas online',
    color: 'black',
    class: 'event-closed',
    icon: <Icon as={IoMdCloseCircle} height={12} width={12} color="#DD6B20" />,
    text: 'Este evento não está liberado para vendas online. Para habilitar, vincule uma conta de repasse em "Meus eventos".',
  },
];

export default eventStatus;
